import { Destructable } from "./types";
import { addThreewayDependency } from "./utils";
import DestructableMap from "./DestructableMap";
import DestructableObject from "./DestructableObject";

export default class DestructorPool extends DestructableMap<Destructable, Destructable> {
	get(parent: Destructable): Destructable {
		if (!this.has(parent)) {
			const child = new DestructableObject();
			if (parent.destroyed) {
				child.destroy();
				return child;
			}
			super.set(parent, child);

			addThreewayDependency(this, parent, child, () => {
				super.delete(parent);
				child.destroy();
			});
			return child;
		} else {
			return super.get(parent)!;
		}
	}

	delete(parent: Destructable): boolean {
		if (this.has(parent)) {
			this.get(parent)!.destroy();
		}
		return super.delete(parent);
	}

	destroy(): void {
		const local_values = [...this.values()];
		super.destroy();
		for (const child of local_values) {
			child.destroy();
		}
	}
}
